<template>
    <div>
        <div class="ethnicity-inline-wrap">
                <fe-stepper-checkbox-panel
                    v-model="filterValue.included"
                    :items="inlineEthnicityItems"
                    width="100%"
                    item-value="value"
                    item-text="display_name"
                />
            </div>
    </div>
</template>

<script>
import * as Util from '../../Util'
import FilterUtil from '../../FilterPanelUtil'
import { processDisplayNameGroupItems } from './processDisplayNameGroupItems'

export default {
    name: 'EthnicityPanel',
    rank: 1,

    props: {
        existingFilter: { type: Object, default: null },
    },

    data() {
        return {
            displayName: 'Ethnicity',
            type: 'ethnicity',
            filterValue: { included: [], excluded: [] },
            inlineEthnicityItems: [],
        }
    },

    computed: {
        ethnicityUrl() {
            return this.$models.getUrl('ethnicity', 'read')
        },
        inlineValid() {
            const included = this.filterValue.included || []
            return included.length > 0
        },
        isDirty() {
            // Monitor form state to enable/disable apply button appropriately
            const applied = this.existingFilter?.editorParams
            if (!applied || !applied.ethnicities) return false
            const current = this.filterValue

            const appliedValues = !Array.isArray(applied.ethnicities) ? [] : applied.ethnicities.map(x => x?.value ?? x).sort()
            const currentValues = !Array.isArray(current.included) ? [] : current.included.map(x => x?.value ?? x).sort()
            return appliedValues.length !== currentValues.length || appliedValues.some((v, i) => v !== currentValues[i])
        },
    },

    watch: {
        existingFilter: {
            handler(f) {
                // Sync form state from the applied filter when it changes; clear form when the filter is removed.
                if (f?.editorParams?.ethnicities) {
                    this.filterValue = { included: [...f.editorParams.ethnicities], excluded: [] }
                } else {
                    this.filterValue = { included: [], excluded: [] }
                }
            },
            immediate: true,
        },
        inlineValid: {
            handler(v) {
                this.$emit('valid-change', v)
            },
            immediate: true,
        },
        isDirty: {
            handler(v) {
                this.$emit('dirty-change', v)
            },
            immediate: true,
        },
    },

    mounted() {
        this.$axios.get(this.ethnicityUrl).then((res) => {
            const raw = res?.data?.ethnicity || []
            this.inlineEthnicityItems = processDisplayNameGroupItems(raw)
        })
        this.$emit('valid-change', this.inlineValid)
    },

    methods: {
        getFilter() {
            const included = this.filterValue.included || []
            if (included.length === 0) return null
            const name = included.map(x => x.display_name).join(', ')
            const ids = FilterUtil.collectIdsFromSelection(included, { idKey: 'value', parseInteger: false })
            const filter = {
                type: this.type,
                id: Util.UUIDv4(),
                report: true,
                params: this.$_.pickBy({ ethnicity: ids }, x => !this.$_.isBlank(x)),
            }
            FilterUtil.attachFilterDescriptor(filter, {
                editor: this,
                editorParams: { ethnicities: [...included] },
                chipText: name,
                tooltipData: { Ethnicity: name },
            })
            return filter
        },
    },
}
</script>

<style lang="scss" scoped>
.ethnicity-inline-wrap {
    min-width: 0;
}
.ethnicity-inline-wrap ::v-deep .v-list.fe-stepper-checkbox {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    gap: 0 16px;
}
.ethnicity-inline-wrap ::v-deep .v-list.fe-stepper-checkbox > .v-list-item {
    min-width: 0;
    max-width: 100%;
}
</style>
